import React from 'react';
import { Outlet } from 'react-router-dom';
import SettingsNav from './SettingsNav'; // El menú de navegación que crearemos a continuación
import { useTranslation } from 'react-i18next';

const SettingsLayout = () => {
  const { t } = useTranslation();

  return (
    <div className="container-main my-8">
      <div className="flex flex-col md:flex-row gap-8">
        <aside className="md:w-1/4 lg:w-1/5 flex-shrink-0">
          <h1 className="text-2xl font-bold text-neutral-800 dark:text-white mb-6">
            {t('settings.layout.title')}
          </h1>
          <SettingsNav />
        </aside>
        <main className="flex-1 bg-white dark:bg-neutral-800 p-6 sm:p-8 rounded-xl shadow-card">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default SettingsLayout;
